export default {"src":"/_next/static/media/icon-proven-efficiency.df1ab039.svg","height":141,"width":140,"blurWidth":0,"blurHeight":0};